import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import styles from './Marquee.module.scss';
const Marquee = ({ marketingMarkerText, promotionalMarkerText }) => {
    const promotionRef = useRef(null);
    const marketingRef = useRef(null);
    const containerRef = useRef(null);
    const textElements = [];
    const [clones, setClones] = useState(textElements);
    const [isLoading, setLoading] = useState(true);
    useEffect(() => {
        setLoading(false);
    }, [setClones]);
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        const promotionWidth = ((_a = promotionRef === null || promotionRef === void 0 ? void 0 : promotionRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth)
            ? (_b = promotionRef === null || promotionRef === void 0 ? void 0 : promotionRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth
            : 0;
        const marketingWidth = ((_c = marketingRef === null || marketingRef === void 0 ? void 0 : marketingRef.current) === null || _c === void 0 ? void 0 : _c.offsetWidth)
            ? (_d = marketingRef === null || marketingRef === void 0 ? void 0 : marketingRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth
            : 0;
        const wrapperWidth = promotionWidth + marketingWidth;
        const multiple = Math.ceil((((_e = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _e === void 0 ? void 0 : _e.offsetWidth) * 2) / wrapperWidth);
        const evenMultiple = 2 * Math.round(multiple / 2);
        for (let i = 1; i < evenMultiple; i += 1) {
            if (marketingMarkerText) {
                textElements.push({ text: marketingMarkerText, id: `marketing-${i}` });
            }
            if (promotionalMarkerText) {
                textElements.push({ text: promotionalMarkerText, id: `promotion-${i}` });
            }
        }
        setClones(textElements);
    }, [marketingMarkerText, promotionalMarkerText]);
    return (React.createElement("div", { className: styles.container, ref: containerRef },
        React.createElement("ul", { className: cn(styles.markerWrapper, isLoading && styles.loading) },
            marketingMarkerText && (React.createElement("li", { className: styles.textElement, ref: marketingRef, key: "marketingText" }, marketingMarkerText)),
            promotionalMarkerText && (React.createElement("li", { className: styles.textElement, ref: promotionRef, key: "promotionText" }, promotionalMarkerText)),
            !isLoading &&
                clones.map((clone) => (React.createElement("li", { className: styles.textElement, "aria-hidden": "true", key: clone.id }, clone.text))))));
};
export default Marquee;
//# sourceMappingURL=Marquee.js.map